export default class DefaultDateTypes {
    static Today = 'Today';
    static Yesterday = 'Yesterday';
    static LastWeek = 'Last Week';
    static LastMonth = 'Last Month';
    static Custom = 'Custom';
    static Unknown = 'UnknownRangeType';
}
